export default __webpack_public_path__ + "static/media/skills.957a1f5e.svg";